import {
  getRequest,
  postRequest,
  patchRequest,
  uploadEncodedFile,
  deleteRequest
} from '../../Common/network-call';
import {
  FILES_URL,
  SCRIPT_URI_ADDON,
  TABLE_URI_ADDON
} from '../../../constants/constant';
import { ALLOWED_FORM_LAYOUTS } from '../../../constants/section-constants/editprofile-constants';
import {
  getFormattedFileName,
  getUploadBaseURL
} from '../../../util/util-common';
import { prepareFinalPayload } from '../utils/payload-organizer';
import { ALLOWED_FEATURE_KEYS } from '../../../constants/section-constants/common-constants';
import {
  FETCH_ORDERS,
  FIELDS,
  SCRIPTS,
  TABLES
} from '../../../constants/section-constants/eventify-constant';
import { ALLOWED_GAME_CHALLENGE_TYPES } from '../../../constants/section-constants/gamification-constants';

export const UPDATE_SPEAKERS_FILES = 'UPDATE_SPEAKERS_FILES';
export const SPEAKER_FILES_CHANGED = 'SPEAKER_FILES_CHANGED';
export const WORKING_DYNAMIC_FORM = 'WORKING_DYNAMIC_FORM';
export const FETCH_ALL_PRODUCT_CATEGORY = 'FETCH_ALL_PRODUCT_CATEGORY';
export const FETCH_ALL_PRODUCT_SUB_CATEGORY = 'FETCH_ALL_PRODUCT_SUB_CATEGORY';
export const FETCH_ALL_INDUSTRY = 'FETCH_ALL_INDUSTRY';

export const fetchProductAllCategory = (session, callback) => {
  const eventFilter = encodeURI(
    `((eventid=${session.eventid})AND(isactive=1))`
  );
  const masterFilter = encodeURI(`((eventid IS NULL)AND(isactive=1))`);

  const fetchUrl = `${session.instance_url}${TABLE_URI_ADDON}/${TABLES.masterCategory}?include_count=true&fields=${FIELDS.masterCategory.minInfo}&order=${FETCH_ORDERS.masterCategory.api}`;

  function handleDispatchPayload(res) {
    return {
      data: _.orderBy(
        res?.resource,
        FETCH_ORDERS.masterCategory.internal.fields,
        FETCH_ORDERS.masterCategory.internal.order
      ),
      count: res?.meta?.count
    };
  }

  return dispatch => {
    getRequest(
      `${fetchUrl}&filter=${eventFilter}`,
      session,
      dispatch,
      eventBasedData => {
        if (
          _.isEmpty(eventBasedData?.resource) ||
          !eventBasedData?.meta?.count
        ) {
          getRequest(
            `${fetchUrl}&filter=${masterFilter}`,
            session,
            dispatch,
            masterData => {
              const dispatchPayload = handleDispatchPayload(masterData);

              dispatch({
                type: FETCH_ALL_PRODUCT_CATEGORY,
                payload: dispatchPayload
              });
              callback &&
                callback({
                  success: 1,
                  ...dispatchPayload,
                  error: null
                });
            },
            error => {
              callback && callback({ success: 0, error });
            }
          );
        } else {
          const dispatchPayload = handleDispatchPayload(eventBasedData);

          dispatch({
            type: FETCH_ALL_PRODUCT_CATEGORY,
            payload: dispatchPayload
          });
          callback &&
            callback({
              success: 1,
              ...dispatchPayload
            });
        }
      },
      error => {
        callback && callback({ success: 0, error });
      }
    );
  };
};

export const fetchProductAllSubCategory = (session, callback) => {
  const eventFilter = encodeURI(
    `((eventid=${session.eventid})AND(isactive=1))`
  );
  const masterFilter = encodeURI(`((eventid IS NULL)AND(isactive=1))`);

  const fetchUrl = `${session.instance_url}${TABLE_URI_ADDON}/${TABLES.masterSubCategory}?fields=${FIELDS.masterSubCategory.minInfo}&include_count=true&order=${FETCH_ORDERS.masterSubCategory}`;

  return dispatch => {
    getRequest(
      `${fetchUrl}&filter=${eventFilter}`,
      session,
      dispatch,
      eventBasedData => {
        if (
          _.isEmpty(eventBasedData?.resource) ||
          !eventBasedData?.meta?.count
        ) {
          getRequest(
            `${fetchUrl}&filter=${masterFilter}`,
            session,
            dispatch,
            masterData => {
              dispatch({
                type: FETCH_ALL_PRODUCT_SUB_CATEGORY,
                payload: {
                  data: masterData?.resource,
                  count: masterData?.meta?.count
                }
              });
              callback &&
                callback({
                  success: 1,
                  data: masterData?.resource,
                  count: masterData?.meta?.count
                });
            },
            error => {
              callback && callback({ success: 0, error });
            }
          );
        } else {
          dispatch({
            type: FETCH_ALL_PRODUCT_SUB_CATEGORY,
            payload: {
              data: eventBasedData?.resource,
              count: eventBasedData?.meta?.count
            }
          });
          callback &&
            callback({
              success: 1,
              data: eventBasedData?.resource,
              count: eventBasedData?.meta?.count
            });
        }
      },
      error => {
        callback && callback({ success: 0, error });
      }
    );
  };
};

export const fetchAllIndustries = (session, callback) => {
  const eventFilter = encodeURI(
    `((eventid=${session.eventid})AND(isactive=1))`
  );
  const masterFilter = encodeURI(`((eventid IS NULL)AND(isactive=1))`);

  const fetchUrl = `${session.instance_url}${TABLE_URI_ADDON}/${TABLES.masterIndustry}?include_count=true&fields=${FIELDS.masterIndustry.minInfo}&order=${FETCH_ORDERS.masterIndustry.api}`;

  function handleDispatchPayload(res) {
    return {
      data: _.orderBy(
        res?.resource,
        FETCH_ORDERS.masterIndustry.internal.fields,
        FETCH_ORDERS.masterIndustry.internal.order
      ),
      count: res?.meta?.count
    };
  }

  return dispatch => {
    getRequest(
      `${fetchUrl}&filter=${eventFilter}`,
      session,
      dispatch,
      eventBasedData => {
        if (
          _.isEmpty(eventBasedData?.resource) ||
          !eventBasedData?.meta?.count
        ) {
          getRequest(
            `${fetchUrl}&filter=${masterFilter}`,
            session,
            dispatch,
            masterData => {
              const dispatchPayload = handleDispatchPayload(masterData);
              dispatch({
                type: FETCH_ALL_INDUSTRY,
                payload: dispatchPayload
              });
              callback &&
                callback({
                  success: 1,
                  ...dispatchPayload
                });
            },
            error => {
              callback && callback({ success: 0, error });
            }
          );
        } else {
          const dispatchPayload = handleDispatchPayload(eventBasedData);
          dispatch({
            type: FETCH_ALL_INDUSTRY,
            payload: dispatchPayload
          });
          callback &&
            callback({
              success: 1,
              ...dispatchPayload
            });
        }
      },
      error => {
        callback && callback({ success: 0, error });
      }
    );
  };
};

export const saveAppUser = (
  session,
  appuserId,
  values,
  isdynamicFileChanged,
  workingDynamicForm,
  formLayout,
  callback
) => {
  let profileImage = values.profileimagehidden ?? '';
  let profileCoverImage = values.profilecoverimagehidden ?? '';
  let profileFrame = values.frameurlhidden ?? '';
  let profileVideo = values.videourlhidden ?? '';

  if (profileImage === 'removed') {
    values.profileurl = null;
  }
  if (profileCoverImage === 'removed') {
    values.coverimage = null;
  }
  if (profileFrame === 'removed') {
    values.frameurl = null;
  }
  if (profileVideo === 'removed') {
    values.videourl = null;
  }

  // --- Local data hold and a flag value
  let interestByAppuser = values?.userinterests_by_appuserid
    ? values.userinterests_by_appuserid
    : [];

  // Fetch dynamic field responses
  let responsesArray = JSON.parse(values.responses);
  let otherFilesData = [];
  if (formLayout === ALLOWED_FORM_LAYOUTS.single) {
    _.map(workingDynamicForm.form, formItem => {
      _.map(formItem.section_items, secItem => {
        if (secItem.key === 'file') otherFilesData.push(secItem);
      });
    });
  } else {
    otherFilesData = _.filter(workingDynamicForm.form, obj => {
      return obj.key === 'file';
    });
  }

  // profile image upload path
  let filename = getFormattedFileName(
    session,
    '',
    ALLOWED_FEATURE_KEYS.profile,
    { ext: 'jpg' }
  );
  let coverFilePath = getFormattedFileName(
    session,
    '',
    ALLOWED_FEATURE_KEYS.profile,
    { ext: 'jpg' }
  );
  let videoFilePath = getFormattedFileName(
    session,
    '',
    ALLOWED_FEATURE_KEYS.profile,
    { ext: 'mp4' }
  );

  return dispatch => {
    // --- Profile image is getting uploaded
    _uploadImage(session, profileImage, filename, dispatch, profile => {
      // NOTE: _uploadImage function checks if image uplaod needed, if nothing to uplaod sends success as true back
      if (profile.success) {
        _uploadImage(
          session,
          profileCoverImage,
          coverFilePath,
          dispatch,
          coverRes => {
            if (coverRes.success) {
              _uploadImage(
                session,
                profileVideo,
                videoFilePath,
                dispatch,
                videoRes => {
                  if (videoRes.success) {
                    _uploadDynamicFormsFiles(
                      session,
                      otherFilesData,
                      isdynamicFileChanged,
                      'appuser',
                      dispatch,
                      filesArray => {
                        if (isdynamicFileChanged == true) {
                          _.map(filesArray, obj => {
                            let check = _.filter(responsesArray, file => {
                              return file.name === obj.name;
                            });
                            if (check.length > 0)
                              check[0].value = obj.fileArray;
                          });
                        }

                        // --- Assigning profile image path into appUser value
                        let local_values = {
                          ..._.cloneDeep(values),
                          eventid: session.eventid,
                          ...(profile.data && profile.data.path
                            ? {
                                profileurl: profile.data.path
                              }
                            : {}),
                          ...(coverRes.data && coverRes.data.path
                            ? {
                                coverimage: coverRes.data.path
                              }
                            : {}),
                          ...(videoRes.data && videoRes.data.path
                            ? {
                                videourl: videoRes.data.path
                              }
                            : {}),
                          responses: JSON.stringify(responsesArray)
                        };

                        delete local_values['profileimagehidden'];
                        delete local_values['profilecoverimagehidden'];
                        delete local_values['frameurlhidden'];
                        delete local_values['videourlhidden'];

                        // --- Image upload flag
                        let isImageUpload =
                          profile.data && profile.data.path ? true : false;

                        dispatch(
                          createUpdateAppuser(
                            session,
                            appuserId,
                            local_values,
                            isImageUpload,
                            interestByAppuser,
                            res => {
                              callback(res.success);
                            }
                          )
                        );
                      }
                    );
                  } else {
                    callback({
                      success: 2,
                      data: {
                        step: 'video',
                        profile_success: profile.success,
                        cover_success: coverRes.success,
                        video_success: videoRes.message,
                        error: videoRes.message
                      }
                    });
                  }
                }
              );
            } else {
              callback({
                success: 2,
                data: {
                  step: 'cover',
                  profile_success: profile.success,
                  cover_success: coverRes.success,
                  video_success: null,
                  error: coverRes.message
                }
              });
            }
          }
        );
      } else {
        callback({
          success: 2,
          data: {
            step: 'profile',
            profile_success: profile.success,
            cover_success: null,
            video_success: null,
            error: profile.message
          }
        });
      }
    });
  };
};

const gamePointForProfileUpload = (session, appuserid, callback) => {
  let challengeUrl = `${session.instance_url}${SCRIPT_URI_ADDON}/${SCRIPTS.gamificationScript.fetchGameChallengeStatus.endpoint}`;
  let challengeBody = _.cloneDeep(
    SCRIPTS.gamificationScript.fetchGameChallengeStatus.payload
  );
  challengeBody.eventid = session.eventid;
  challengeBody.userid = appuserid;
  challengeBody.challengetype =
    ALLOWED_GAME_CHALLENGE_TYPES.types.completeprofile;
  challengeBody.type = 'uploadimage';

  return dispatch => {
    postRequest(
      challengeUrl,
      challengeBody,
      session,
      dispatch,
      feedback => {
        let uploadPoints =
          feedback.resource && feedback.resource.points
            ? feedback.resource.points
            : 0;
        let points = parseInt(uploadPoints);

        if (feedback.resource && feedback.resource.points) {
          feedback.resource.points = points;
        }

        callback({
          success: 1,
          data: feedback.resource
        });
      },
      error => {
        callback({
          success: 0,
          message: error
        });
      }
    );
  };
};

export const createUpdateAppuser = (
  session,
  appuserId,
  values,
  isImageUpload,
  interestByAppuser,
  callback
) => {
  const patchUrl = `${session.instance_url}${TABLE_URI_ADDON}/${TABLES.appuser}/${appuserId}`;
  const patchBody = prepareFinalPayload(
    session.eventid,
    ALLOWED_FEATURE_KEYS.attendee,
    values
  );

  return dispatch => {
    patchRequest(
      patchUrl,
      patchBody,
      session,
      dispatch,
      updateResponse => {
        let gameImageUploadRes = {};
        // --- Assigning gamification points if profile changed (whether to assign or not is checked in the backend gamification script)
        if (isImageUpload) {
          dispatch(
            gamePointForProfileUpload(session, appuserId, res => {
              gameImageUploadRes = res;
            })
          );
        }

        // --- Processing interest selection and associated gamification point assigning
        values.userinterests_by_appuserid = interestByAppuser;
        if (
          !_.isEmpty(values?.userinterests_by_appuserid) ||
          !_.isEmpty(values?.userinterests)
        ) {
          dispatch(
            updateUserInterest(session, appuserId, values, res => {
              if (res.success) {
                callback({
                  success: 1,
                  data: updateResponse,
                  interest: res,
                  gameImageUploadRes
                });
              }
            })
          );
        } else
          callback({
            success: 1,
            data: updateResponse,
            interest: null,
            gameImageUploadRes
          });
      },
      error => {
        callback({ success: 0, message: error });
      }
    );
  };
};

export const updateUserInterest = (session, appuserId, values, callback) => {
  let filter = encodeURI(
    `(eventid=${session.eventid})AND(appuserid=${appuserId})`
  );
  let deleteUrl = `${session.instance_url}${TABLE_URI_ADDON}/${TABLES.userinterests}?filter=(${filter})`;
  let insertUrl = `${session.instance_url}${TABLE_URI_ADDON}/${TABLES.userinterests}`;

  let interests = [];
  values.userinterests.map(item => {
    interests.push({
      eventid: session.eventid,
      appuserid: appuserId,
      interestid: item
    });
  });
  let body = { resource: interests };

  if (values?.userinterests_by_appuserid?.length > 0) {
    return dispatch => {
      deleteRequest(
        deleteUrl,
        session,
        dispatch,
        delres => {
          if (body.resource.length > 0) {
            postRequest(
              insertUrl,
              body,
              session,
              dispatch,
              response => {
                let challengeUrl = `${session.instance_url}${SCRIPT_URI_ADDON}/${SCRIPTS.gamificationScript.fetchGameChallengeStatus.endpoint}`;
                let challengeBody = _.cloneDeep(
                  SCRIPTS.gamificationScript.fetchGameChallengeStatus.payload
                );
                challengeBody.eventid = session.eventid;
                challengeBody.userid = values.appuserid;
                challengeBody.challengetype =
                  ALLOWED_GAME_CHALLENGE_TYPES.types.completeprofile;
                challengeBody.type = 'addinterest';

                postRequest(
                  challengeUrl,
                  challengeBody,
                  session,
                  dispatch,
                  gamResponse => {
                    callback({
                      success: 1,
                      challangesuccess: 1,
                      data: gamResponse.resource
                    });
                  },
                  error => {
                    callback({
                      success: 1,
                      challangesuccess: 0,
                      message: error
                    });
                  }
                );
              },
              error => {
                callback({ success: 0, message: error });
              }
            );
          } else {
            callback({ success: 1, challangesuccess: 0 });
          }
        },
        error => {
          callback({ success: 0, message: error });
        }
      );
    };
  } else if (interests?.length > 0) {
    return dispatch => {
      postRequest(
        insertUrl,
        body,
        session,
        dispatch,
        response => {
          let challengeUrl = `${session.instance_url}${SCRIPT_URI_ADDON}/${SCRIPTS.gamificationScript.fetchGameChallengeStatus.endpoint}`;
          let challengeBody = _.cloneDeep(
            SCRIPTS.gamificationScript.fetchGameChallengeStatus.payload
          );
          challengeBody.eventid = session.eventid;
          challengeBody.userid = values.appuserid;
          challengeBody.challengetype =
            ALLOWED_GAME_CHALLENGE_TYPES.types.completeprofile;
          challengeBody.type = 'addinterest';

          postRequest(
            challengeUrl,
            challengeBody,
            session,
            dispatch,
            gamResponse => {
              callback({
                success: 1,
                challangesuccess: 1,
                data: gamResponse.resource
              });
            },
            error => {
              callback({ success: 1, challangesuccess: 0, message: error });
            }
          );
          callback({ success: 1 });
        },
        error => {
          callback({ success: 0, message: error });
        }
      );
    };
  }
  return dispatch => {};
};

export const updateSpeakersFiles = file => {
  return dispatch => {
    dispatch({ type: UPDATE_SPEAKERS_FILES, payload: file });
  };
};

export const speakerAttachmentChanged = bool => {
  return dispatch => {
    dispatch({ type: SPEAKER_FILES_CHANGED, payload: bool });
  };
};

export const saveSpeaker = (
  session,
  speakerId,
  values,
  uploadFiles,
  filechanged,
  callback
) => {
  let profileImage = values.profileimagehidden ? values.profileimagehidden : '';

  let filename = getFormattedFileName(
    session,
    '',
    ALLOWED_FEATURE_KEYS.speaker,
    { ext: 'jpg' }
  );

  if (profileImage === 'removed') {
    values.profileimage = '';
    values.profilethumbimage = '';
  }

  return dispatch => {
    if (profileImage.search(';base64,') > 0 && filechanged == true) {
      _uploadProfile(session, profileImage, filename, dispatch, profile => {
        if (profile.success) {
          _uploadAttachedFiles(session, uploadFiles, dispatch, attachments => {
            let local_values = {
              ..._.cloneDeep(values),
              profileimage: profile.data.path,
              profilethumbimage: profile.data.path,
              file1: attachments[0].file,
              file2: attachments[1].file,
              file3: attachments[2].file,
              file4: attachments[3].file,
              file5: attachments[4].file,
              eventid: session.eventid
            };

            dispatch(
              createUpdateSpeaker(session, speakerId, local_values, callback)
            );
          });
        } else {
          callback({ error: 2, data: profile.data.message });
        }
      });
    } else if (profileImage.search(';base64,') > 0 && filechanged == false) {
      _uploadProfile(session, profileImage, filename, dispatch, profile => {
        if (profile.success) {
          let local_values = {
            ..._.cloneDeep(values),
            profileimage: profile.data.path,
            profilethumbimage: profile.data.path,
            eventid: session.eventid
          };

          dispatch(
            createUpdateSpeaker(session, speakerId, local_values, callback)
          );
        } else {
          callback({ success: 2, data: profile.message });
        }
      });
    } else if (profileImage.search(';base64,') < 0 && filechanged == true) {
      _uploadAttachedFiles(session, uploadFiles, dispatch, attachments => {
        let local_values = {
          ..._.cloneDeep(values),
          file1: attachments[0].file,
          file2: attachments[1].file,
          file3: attachments[2].file,
          file4: attachments[3].file,
          file5: attachments[4].file,
          eventid: session.eventid
        };

        dispatch(
          createUpdateSpeaker(session, speakerId, local_values, callback)
        );
      });
    } else {
      let local_values = { ..._.cloneDeep(values), eventid: session.eventid };

      dispatch(createUpdateSpeaker(session, speakerId, local_values, callback));
    }
  };
};

export const createUpdateSpeaker = (session, speakerId, values, callback) => {
  const patchUrl = `${session.instance_url}${TABLE_URI_ADDON}/${TABLES.speaker}/${speakerId}`;
  const patchBody = prepareFinalPayload(
    session.eventid,
    ALLOWED_FEATURE_KEYS.speaker,
    values
  );

  return dispatch => {
    patchRequest(
      patchUrl,
      patchBody,
      session,
      dispatch,
      data => {
        callback({ success: 1, response: data });
      },
      error => {
        callback({ success: 0, message: error });
      }
    );
  };
};

export const updateWorkingForm = data => {
  return dispatch => {
    dispatch({ type: WORKING_DYNAMIC_FORM, payload: data });
  };
};

export const saveSponsor = (
  session,
  sponsorId,
  values,
  isdynamicFileChanged,
  workingDynamicForm,
  formLayout,
  callback
) => {
  let profileImage = values.logoimagehidden ? values.logoimagehidden : '';
  let bannerImage = values.bannerimagehidden ? values.bannerimagehidden : '';
  let logofilename = getFormattedFileName(
    session,
    '',
    ALLOWED_FEATURE_KEYS.sponsor,
    { ext: 'jpg', section: 'logo' }
  );
  let bannerfilename = getFormattedFileName(
    session,
    '',
    ALLOWED_FEATURE_KEYS.sponsor,
    { ext: 'jpg', section: 'banner' }
  );

  if (profileImage === 'removed') {
    values.logoimgpath = '';
    values.logothumbimgpath = '';
  }
  if (bannerImage === 'removed') {
    values.bannerimage = '';
  }

  // Fetch only files field
  let otherFilesData = [];
  if (formLayout === ALLOWED_FORM_LAYOUTS.single) {
    _.map(workingDynamicForm.form, formItem => {
      _.map(formItem.section_items, secItem => {
        if (secItem.key === 'file') otherFilesData.push(secItem);
      });
    });
  } else {
    otherFilesData = _.filter(workingDynamicForm.form, obj => {
      return obj.key === 'file';
    });
  }

  // Fetch dynamic field responses
  let responsesArray = JSON.parse(values.responses);

  return dispatch => {
    _uploadImage(session, profileImage, logofilename, dispatch, profile => {
      if (profile.success) {
        _uploadImage(session, bannerImage, bannerfilename, dispatch, banner => {
          if (banner.success) {
            _uploadDynamicFormsFiles(
              session,
              otherFilesData,
              isdynamicFileChanged,
              'sponsors',
              dispatch,
              filesArray => {
                if (isdynamicFileChanged == true) {
                  _.map(filesArray, obj => {
                    let check = _.filter(responsesArray, file => {
                      return file.name === obj.name;
                    });
                    check[0].value = obj.fileArray;
                  });
                }

                let local_values = {
                  ..._.cloneDeep(values),
                  eventid: session.eventid,
                  ...(profile.data && profile.data.path
                    ? {
                        logoimgpath: profile.data.path,
                        logothumbimgpath: profile.data.path
                      }
                    : {}),
                  ...(banner.data && banner.data.path
                    ? {
                        bannerimage: banner.data.path
                      }
                    : {}),
                  responses: JSON.stringify(responsesArray)
                };
                delete local_values['logoimagehidden'];
                delete local_values['bannerimagehidden'];

                dispatch(
                  createUpdateSponsor(
                    session,
                    sponsorId,
                    local_values,
                    callback
                  )
                );
              }
            );
          } else {
            callback({ error: 2 });
          }
        });
      } else {
        callback({ error: 2 });
      }
    });
  };
};

export const createUpdateSponsor = (session, sponsorId, values, callback) => {
  const patchUrl = `${session.instance_url}${TABLE_URI_ADDON}/${TABLES.sponsor}/${sponsorId}`;
  const patchBody = prepareFinalPayload(
    session.eventid,
    ALLOWED_FEATURE_KEYS.sponsor,
    values
  );

  return dispatch => {
    patchRequest(
      patchUrl,
      patchBody,
      session,
      dispatch,
      data => {
        callback({ success: 1, response: data });
      },
      error => {
        callback({ success: 0, message: error });
      }
    );
  };
};

export const saveExhibitor = (
  session,
  exhibitorId,
  values,
  isdynamicFileChanged,
  workingDynamicForm,
  formLayout,
  callback
) => {
  let profileImage = values.logoimagehidden ? values.logoimagehidden : '';
  let bannerImage = values.bannerimagehidden ? values.bannerimagehidden : '';
  let logofilename = getFormattedFileName(
    session,
    '',
    ALLOWED_FEATURE_KEYS.exhibitor,
    { ext: 'jpg', section: 'logo' }
  );
  let bannerfilename = getFormattedFileName(
    session,
    '',
    ALLOWED_FEATURE_KEYS.exhibitor,
    { ext: 'jpg', section: 'banner' }
  );

  if (profileImage === 'removed') {
    values.profileimage = '';
    values.profilethumbimage = '';
  }
  if (bannerImage === 'removed') {
    values.bannerimage = '';
  }

  let otherFilesData = [];
  if (formLayout === ALLOWED_FORM_LAYOUTS.single) {
    _.map(workingDynamicForm.form, formItem => {
      _.map(formItem.section_items, secItem => {
        if (secItem.key === 'file') otherFilesData.push(secItem);
      });
    });
  } else {
    otherFilesData = _.filter(workingDynamicForm.form, obj => {
      return obj.key === 'file';
    });
  }

  // Fetch dynamic field responses
  let responsesArray = JSON.parse(values.responses);

  // Remove blank group fields
  _.map(responsesArray, obj => {
    if (obj.key === 'group' && obj.value && obj.value.length > 0) {
      if (obj.type === 'products') {
        let newArray = _.filter(obj.value, o => {
          return (
            o.productimages != '' ||
            o.productcategory != '' ||
            o.productsubcategory != '' ||
            o.producttitle != '' ||
            o.productinfo != ''
          );
        });
        obj.value = newArray;
      } else if (obj.type === 'coupons') {
        let newArray = _.filter(obj.value, o => {
          return (
            o.coupontitle != '' ||
            o.couponabout != '' ||
            o.couponecode != '' ||
            o.couponvalidtill != ''
          );
        });
        obj.value = newArray;
      } else if (obj.type === 'deals') {
        let newArray = _.filter(obj.value, o => {
          return (
            o.dealtitle != '' || o.dealabout != '' || o.dealvalidtill != ''
          );
        });
        obj.value = newArray;
      }
    }
  });

  // Fetch only product group field data
  let groupProductData = _.filter(responsesArray, data => {
    return data.key === 'group' && data.type === 'products';
  });
  let groupProductValue =
    groupProductData.length > 0 ? groupProductData[0].value : [];

  return dispatch => {
    _uploadImage(session, profileImage, logofilename, dispatch, profile => {
      if (profile.success) {
        _uploadImage(session, bannerImage, bannerfilename, dispatch, banner => {
          if (banner.success) {
            _uploadDynamicFormsFiles(
              session,
              otherFilesData,
              isdynamicFileChanged,
              'exhibitors',
              dispatch,
              filesArray => {
                _uploadGroupProductImage(
                  session,
                  groupProductValue,
                  dispatch,
                  product => {
                    let check = _.filter(responsesArray, data => {
                      return data.key === 'group' && data.type === 'products';
                    });
                    if (check.length > 0) check[0].value = product;

                    if (isdynamicFileChanged == true) {
                      _.map(filesArray, obj => {
                        let check = _.filter(responsesArray, file => {
                          return file.name === obj.name;
                        });
                        if (check.length > 0) check[0].value = obj.fileArray;
                      });
                    }

                    let local_values = {
                      ..._.cloneDeep(values),
                      eventid: session.eventid,
                      ...(profile.data && profile.data.path
                        ? {
                            profileimage: profile.data.path,
                            profilethumbimage: profile.data.path
                          }
                        : {}),
                      ...(banner.data && banner.data.path
                        ? {
                            bannerimage: banner.data.path
                          }
                        : {}),
                      responses: JSON.stringify(responsesArray)
                    };
                    delete local_values['logoimagehidden'];
                    delete local_values['bannerimagehidden'];

                    createUpdateExhibitor(
                      session,
                      exhibitorId,
                      local_values,
                      dispatch,
                      feedback => {
                        if (feedback.success) {
                          callback({ success: 1 });
                        } else {
                          callback({ success: 0, message: feedback.message });
                        }
                      }
                    );
                  }
                );
              }
            );
          } else {
            callback({ success: 3 });
          }
        });
      } else {
        callback({ success: 2 });
      }
    });
  };
};

export const createUpdateExhibitor = (
  session,
  exhibitorId,
  values,
  dispatch,
  callback
) => {
  const patchUrl = `${session.instance_url}${TABLE_URI_ADDON}/${TABLES.exhibitors}/${exhibitorId}`;
  const patchBody = prepareFinalPayload(
    session.eventid,
    ALLOWED_FEATURE_KEYS.exhibitor,
    values
  );

  patchRequest(
    patchUrl,
    patchBody,
    session,
    dispatch,
    data => {
      callback({ success: 1, exhibitorid: data?.exhibitorid });
    },
    error => {
      callback({ success: 0, message: error });
    }
  );
};

export const _uploadProfile = (
  session,
  imagedata,
  filename,
  dispatch,
  callback
) => {
  imagedata = imagedata.replace(/^data:image\/[a-z]+;base64,/, '');
  let imageJson = {
    resource: [
      {
        name: filename,
        type: 'file',
        is_base64: true,
        content: imagedata
      }
    ]
  };

  uploadEncodedFile(
    `${getUploadBaseURL(session)}${FILES_URL}?check_exist=false`,
    session,
    imageJson,
    dispatch,
    data => {
      callback({ success: 1, data: data });
    },
    error => {
      callback({ success: 0, message: error });
    }
  );
};

export const _uploadImage = (
  session,
  imagedata,
  filename,
  dispatch,
  callback
) => {
  if (imagedata.search(';base64,') > 0) {
    // imagedata = imagedata.replace(/^data:image\/[a-z]+;base64,/, '');
    imagedata = imagedata.split(';base64,')[1]; // Makes this function capatible to upload any files if that's in base64 format

    let imageJson = {
      resource: [
        {
          name: filename,
          type: 'file',
          is_base64: true,
          content: imagedata
        }
      ]
    };

    uploadEncodedFile(
      `${getUploadBaseURL(session)}${FILES_URL}?check_exist=false`,
      session,
      imageJson,
      dispatch,
      data => {
        callback({ success: 1, data: data });
      },
      error => {
        callback({ success: 0, message: error });
      }
    );
  } else {
    callback({ success: 1 });
  }
};

export const _uploadAttachedFiles = (
  session,
  uploadFiles,
  dispatch,
  callback
) => {
  let promiseArray = [];
  _.map(uploadFiles, (item, index) => {
    promiseArray.push(
      new Promise((resolve, reject) => {
        let file = item.file ? item.file : '';

        let n = file.search(';base64,');
        if (n > 0) {
          let imageJson = {
            resource: [
              {
                name: getFormattedFileName(session, item.filename, 'dynamic', {
                  section: 'speakers'
                }),
                type: 'file',
                is_base64: true,
                content: file.split(';base64,')[1]
              }
            ]
          };
          uploadEncodedFile(
            `${getUploadBaseURL(session)}${FILES_URL}?check_exist=false`,
            session,
            imageJson,
            dispatch,
            data => {
              uploadFiles[index].file = data.name;
              resolve();
            },
            error => {
              // callback({success:2, message:error});
            }
          );
        } else if (file == '') {
          uploadFiles[index].file = null;
          resolve();
        } else {
          uploadFiles[index].file = file;
          resolve();
        }
      })
    );
  });

  Promise.all(promiseArray).then(() => {
    callback({ ...uploadFiles });
  });
};

export const _uploadDynamicFormsFiles = (
  session,
  otherFilesData,
  isdynamicFileChanged,
  comesFrom,
  dispatch,
  callback
) => {
  // uploadFiles

  if (isdynamicFileChanged) {
    let promiseArray = [];

    _.map(otherFilesData, (field, key) => {
      // Files field array
      let uploadFiles = field.fileArray;
      const fileCategory =
        comesFrom === 'appuser'
          ? null
          : field.name === 'galleryimages'
          ? 'galleryimages'
          : field.name === 'galleryvideos'
          ? 'galleryvideos'
          : field.name === 'documents'
          ? 'documents'
          : 'otherfiles';

      _.map(uploadFiles, (item, index) => {
        if (item) {
          promiseArray.push(
            new Promise((resolve, reject) => {
              let file = item.file;
              let n = file.search(';base64,');
              if (n > 0) {
                let uploadFileJSON = {
                  resource: [
                    {
                      name: getFormattedFileName(
                        session,
                        item.filename,
                        'dynamic',
                        { section: comesFrom, category: fileCategory }
                      ),
                      type: 'file',
                      is_base64: true,
                      content: file.split(';base64,')[1]
                    }
                  ]
                };

                // --- Uploads file to aws server but for videos uploads to local [ file3 ]
                uploadEncodedFile(
                  `${getUploadBaseURL(session)}${FILES_URL}?check_exist=false`,
                  session,
                  uploadFileJSON,
                  dispatch,
                  data => {
                    if (fileCategory == 'galleryvideos') {
                      let thumbJson = {
                        ...getFormattedFileName(
                          session,
                          item.filename,
                          'galleryVideoThumb',
                          { section: comesFrom }
                        )
                      };

                      dispatch(
                        _createVideoThumbnails(session, thumbJson, res => {
                          if (!res.success) {
                            callback(res);
                          }
                        })
                      );
                    }

                    uploadFiles[index] = data.name;
                    resolve();
                  },
                  error => {}
                );
              } else {
                // upload not required
                uploadFiles[index] = file;
                resolve();
              }
            })
          );
        }
      });

      field.fileArray = uploadFiles;
    });

    Promise.all(promiseArray).then(() => {
      callback(otherFilesData);
    });
  } else {
    callback({ success: 1 });
  }
};

export const _uploadGroupProductImage = (
  session,
  uploadFiles,
  dispatch,
  callback
) => {
  let promiseArray = [];
  _.map(uploadFiles, (item, index) => {
    promiseArray.push(
      new Promise((resolve, reject) => {
        let file = item.productimages;
        let n = file.search(';base64,');
        if (n > 0) {
          let imageJson = {
            resource: [
              {
                name: getFormattedFileName(session, '', 'dynamic', {
                  section: 'exhibitors',
                  category: 'productimages',
                  ext: 'jpg'
                }),
                type: 'file',
                is_base64: true,
                content: file.split(';base64,')[1]
              }
            ]
          };
          uploadEncodedFile(
            `${getUploadBaseURL(session)}${FILES_URL}?check_exist=false`,
            session,
            imageJson,
            dispatch,
            data => {
              uploadFiles[index].productimages = data.name;
              resolve();
            },
            error => {
              // callback({success:2, message:error});
            }
          );
        } else if (file == '') {
          uploadFiles[index].productimages = '';
          resolve();
        } else {
          uploadFiles[index].productimages = file;
          resolve();
        }
      })
    );
  });

  Promise.all(promiseArray).then(() => {
    callback(uploadFiles);
  });
};

export const _createVideoThumbnails = (session, postBody, callback) => {
  let postUrl = `${session.instance_url}${SCRIPT_URI_ADDON}/${SCRIPTS.eventifyScriptSupport.videoThumb.endpoint}`;

  let payload = {
    ..._.cloneDeep(SCRIPTS.eventifyScriptSupport.videoThumb.payload),
    ...postBody
  };
  payload.eventid = session.eventid;

  return dispatch => {
    postRequest(
      postUrl,
      payload,
      session,
      dispatch,
      res => {
        callback({ success: 1, data: res });
      },
      error => {
        callback({ success: 0, message: error });
      }
    );
  };
};
